import { z } from 'zod';

import logger from '@/utils/logger';

export const envSchema = z.object({
  VITE_MODE: z.enum(['development', 'production', 'test']).default('development'),
  VITE_API_URL: z.string().default('/api'),
  VITE_CLOUDFLARE_SITE_KEY: z.string().optional(),
  VITE_GA_TRACKING_ID: z.string().optional(),
  VITE_GTM_ID: z.string().optional(),
});

export type Env = z.infer<typeof envSchema>;

const getEnv = (): Env => {
  const result = envSchema.safeParse(import.meta.env);

  if (!result.success) {
    if (import.meta.env.PROD) {
      logger.error('Environment validation failed:', result.error.flatten());
    } else {
      logger.error('Config validation issues:', result.error.flatten().fieldErrors);
    }
    return envSchema.parse({});
  }

  return result.data;
};

export const ENV = getEnv();
